// extracted by mini-css-extract-plugin
export var center = "_45-2";
export var clickableRow = "_45-5";
export var expandedRow = "_45-7";
export var hoverable = "_45-4";
export var left = "_45-1";
export var right = "_45-3";
export var row = "_45-0";
export var selectedRow = "_45-6";
export var summaryRow = "_45-8";